module.exports = __webpack_public_path__ + "img/qrcode2.20ba33ec.png";